module.exports = __webpack_public_path__ + "static/img/4_2_1.9cec5b1f.jpg";